import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { AUDIT_COMMENT_LIKES } from 'root/src/shared/descriptions/endpoints/endpointIds'
import updateCommentLikes from 'root/src/client/logic/comment/actions/updateCommentLikes'

export default payload => async (dispatch) => {
	const { body, statusCode } = await dispatch(apiRequest(AUDIT_COMMENT_LIKES, payload))
	if (statusCode === 200) {
		dispatch(updateCommentLikes(body))
	}
}
